// extracted by mini-css-extract-plugin
export default {"zrb":"index_zrb_AEsgd","footer":"index_footer_Twla6","commomAd":"index_commomAd_UnKHL"};